import {Base} from "@/api/Base"

export class SubjectAdd extends Base {
    path = "subject/add"
}